// release-recipe-execution-control-env-keys.ts — review 04b H1 (Luke chốt
// hướng B, 2026-10-07; spec V2 §4.2).
//
// VÌ SAO: `~/.avatar/secrets/<id>/test.env` thuộc CÙNG OS user với worker —
// code test do worker viết (recipe ticket, không qua hook) hoặc tool Write tạo
// được file này trước G3, và người duyệt G3 không thấy nó. Nếu `test.env` cấp
// được `PATH`/`NODE_OPTIONS`/`LD_PRELOAD`… cho recipe RELEASE thì worker chọn
// được binary/thư viện mà deploy chạy — đúng process đang cầm credential
// production (stdin hoặc shell) ⇒ rút credential ra ngoài.
//
// Danh sách = mọi key mà loader/runtime/công cụ đọc để quyết định CHẠY CÁI GÌ
// hoặc NÓI CHUYỆN VỚI AI (proxy, CA). BEST-EFFORT: key dữ liệu (`DEPLOY_URL`…)
// vẫn tới release khi không có stdin (in tên ra stderr — M-b); ranh giới thật
// là chế độ `--release-secrets-stdin` (bỏ hẳn `test.env`). So khớp KHÔNG phân biệt hoa thường
// (`https_proxy`, `npm_config_*` có cả hai dạng; Windows env không phân biệt).
// Chỉ áp cho `test.env` → recipe release khi không có stdin; ticket giữ
// `test.env` > shell (credential thử, rủi ro đã chấp nhận ở §4.2).
const EXECUTION_CONTROL_ENV_KEY_PATTERNS: readonly RegExp[] = [
  /^PATH$/i, // chọn `node`/`npm`/`sh` nào được chạy
  /^NODE_OPTIONS$/i, // `--require` nạp code tuỳ ý vào mọi process node
  /^NODE_PATH$/i, // đổi module được `require`
  /^NODE_EXTRA_CA_CERTS$/i, // CA giả ⇒ MITM kết nối deploy
  /^LD_/i, // LD_PRELOAD/LD_LIBRARY_PATH — chèn thư viện (Linux)
  /^DYLD_/i, // DYLD_INSERT_LIBRARIES… — chèn thư viện (macOS)
  /^BASH_ENV$/i, // bash không tương tác source file này khi khởi động
  /^ENV$/i, // sh/dash source file này
  /^PYTHON/i, // PYTHONPATH/PYTHONSTARTUP… — nạp code python tuỳ ý
  /^npm_config_/i, // registry/userconfig/script-shell của npm
  /_PROXY$/i, // HTTP(S)_PROXY/ALL_PROXY — dẫn traffic deploy qua máy lạ
  /^SSL_CERT_FILE$/i, // CA giả (OpenSSL)
  /^SSL_CERT_DIR$/i, // CA giả (OpenSSL)
  /^GIT_/i, // GIT_SSH_COMMAND/GIT_EXEC_PATH/GIT_CONFIG_* — chạy lệnh tuỳ ý
  // Review vòng sửa 04b Q3 (L-a). KHÔNG `^NODE_` chung — `NODE_ENV` là dữ liệu hợp lệ.
  /^HOME$/i, // đổi `~/.npmrc`, `~/.gitconfig`, `~/.ssh` mà công cụ đọc
  /^XDG_/i, // git đọc `$XDG_CONFIG_HOME/git/config` ⇒ core.sshCommand
  /^PERL5/i, // PERL5LIB/PERL5OPT — nạp code perl tuỳ ý
  /^RUBY(OPT|LIB)$/i, // RUBYOPT `-r`, RUBYLIB — nạp code ruby tuỳ ý
  /^(JAVA_TOOL_OPTIONS|_JAVA_OPTIONS|JDK_JAVA_OPTIONS|CLASSPATH)$/i, // `-javaagent`, class lạ
  /^NODE_TLS_REJECT_UNAUTHORIZED$/i, // tắt kiểm chứng chỉ ⇒ MITM
  /^(REQUESTS_CA_BUNDLE|CURL_CA_BUNDLE|CURL_HOME)$/i, // CA giả / `.curlrc` lạ
  /^GO(PROXY|FLAGS)$/i, // module proxy lạ / cờ build (`-toolexec`)
  /^(KUBECONFIG|AWS_CONFIG_FILE|DOCKER_HOST|DOCKER_CONFIG)$/i, // exec plugin, credential_process, daemon lạ
  /^SSH_/i, // SSH_ASKPASS chạy lệnh, SSH_AUTH_SOCK dùng agent lạ
];

export function isExecutionControlEnvKey(key: string): boolean {
  return EXECUTION_CONTROL_ENV_KEY_PATTERNS.some((pattern) => pattern.test(key));
}
